import { Route, Switch } from "wouter";
import { LandingPage } from "./components/LandingPage";
import { DocsPage } from "./components/docs/DocsPage";

export default function App() {
  return (
    <Switch>
      <Route path="/" component={LandingPage} />
      <Route path="/docs" component={DocsPage} />
      <Route path="/docs/:section" component={DocsPage} />
      <Route>
        <div className="flex min-h-screen items-center justify-center">
          <div className="text-center">
            <h1 className="text-4xl font-bold mb-4">404</h1>
            <p className="text-zinc-500 dark:text-zinc-400">Page not found</p>
            <a
              href="/"
              className="text-violet-600 dark:text-violet-400 underline mt-4 inline-block"
            >
              Go home
            </a>
          </div>
        </div>
      </Route>
    </Switch>
  );
}
